export interface PagoTranslations {
  TABLE: {
      CONCEPTO: string;
      FECHA: string;
      IMPORTE: string;
      TIPO_RECLAMACION: string;
      PARTE: string;
      ACTIONS: string;
      PAGOS: string;
  };
  // Aquí puedes añadir más secciones de traducción según lo necesites

  // Esta línea es la clave para que el objeto sea indexable por TypeScript
  [key: string]: any;  // Usamos 'any' para simplificar, pero podrías ser más específico si quieres
}

export const pagoTranslations: { [language: string]: PagoTranslations } = {
    en: {
        TABLE: {
            CONCEPTO: "Subject",
            FECHA: "Date",
            IMPORTE: "Amount",
            TIPO_RECLAMACION: "Claim type",
            PARTE: "Part",
            ACTIONS: "Actions",
            PAGOS: "Payments"
        },
    },
    es: {
        TABLE: {
            CONCEPTO: "Concepto",
            FECHA: "Fecha",
            IMPORTE: "Importe",
            TIPO_RECLAMACION: "Tipo Reclamación",
            PARTE: "Parte",
            ACTIONS: "Acciones",
            PAGOS: "Pagos"
        },
    }
};

